import { type IActionGameConfig, MatchType } from '@nova/types';

import actionGameConfigJson from './configs/action-game-config.json';
import { loadOutpostRunsGameConfig } from './match-types/outpost-runs/load-outpost-runs-game-config';
import { loadTerraformingGameConfig } from './match-types/terraforming/load-terraforming-game-config';
import { loadZoneRushGameConfig } from './match-types/zone-rush/load-zone-rush-game-config';

/** Shared AGE action-game base (all match types). Mode overrides live under `match-types/`. */
export const actionGameConfig: IActionGameConfig = actionGameConfigJson;

export const outpostRunsGameConfig = loadOutpostRunsGameConfig(actionGameConfig);
export const zoneRushGameConfig = loadZoneRushGameConfig(actionGameConfig);
export const terraformingGameConfig = loadTerraformingGameConfig(actionGameConfig);

/** Resolves the game config bundle for a match type (base config or mode extension). */
export function getGameConfigForMatchType(matchType: MatchType): IActionGameConfig {
  switch (matchType) {
    case MatchType.outpostRuns:
      return outpostRunsGameConfig;
    case MatchType.zoneRush:
      return zoneRushGameConfig;
    case MatchType.terraforming:
      return terraformingGameConfig;
    default:
      return actionGameConfig;
  }
}
